import { render, staticRenderFns } from "./CustomActivities.vue?vue&type=template&id=0ed5fec1&scoped=true"
import script from "./CustomActivities.vue?vue&type=script&lang=js"
export * from "./CustomActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5fec1",
  null
  
)

export default component.exports